const MARKETING_CONSENT_STORAGE_KEY = 'beestmode_marketing_consent';
const MARKETING_CONSENT_VERSION = '2026-08-14';
const MARKETING_CONSENT_EVENT = 'beestmode:marketing-consent-changed';

const VALID_STATUSES = new Set(['granted', 'denied']);

export const getMarketingConsent = () => {
  if (typeof window === 'undefined') return 'unknown';

  try {
    const storedValue = window.localStorage.getItem(MARKETING_CONSENT_STORAGE_KEY);
    if (!storedValue) return 'unknown';

    const record = JSON.parse(storedValue);
    if (
      record.policyVersion !== MARKETING_CONSENT_VERSION
      || !VALID_STATUSES.has(record.marketing)
    ) {
      return 'unknown';
    }

    return record.marketing;
  } catch (_error) {
    return 'unknown';
  }
};

export const setMarketingConsent = (status) => {
  if (!VALID_STATUSES.has(status)) return false;

  const record = {
    marketing: status,
    timestamp: new Date().toISOString(),
    policyVersion: MARKETING_CONSENT_VERSION,
  };

  try {
    window.localStorage.setItem(MARKETING_CONSENT_STORAGE_KEY, JSON.stringify(record));
  } catch (_error) {
    // The current page can still honor the choice when storage is unavailable.
  }

  window.dispatchEvent(new CustomEvent(MARKETING_CONSENT_EVENT, { detail: record }));
  return true;
};

export const isMarketingConsentGranted = () => getMarketingConsent() === 'granted';

export {
  MARKETING_CONSENT_EVENT,
  MARKETING_CONSENT_STORAGE_KEY,
  MARKETING_CONSENT_VERSION,
};
